// src/contexts/SocketContext.js
import { createContext, useContext, useEffect, useRef, useState } from "react";
import { io } from "socket.io-client";
import { api, API_ORIGIN } from "../apiClient.js";

const SocketContext = createContext(null);

export function SocketProvider({ children }) {
  const socketRef = useRef(null);

  // 1️⃣ 把 token 放進 state
  const [token, setToken] = useState(() => {
    return sessionStorage.getItem("flaskAccessToken") || null;
  });

  const [connected, setConnected] = useState(false);

  // 2️⃣ 讓其他地方可以主動更新 token（登入/登出時呼叫）
  const setAuthToken = (newToken) => {
    if (newToken) {
      sessionStorage.setItem("flaskAccessToken", newToken);
      setToken(newToken);
    } else {
      sessionStorage.removeItem("flaskAccessToken");
      setToken(null);
    }
  };

  // 3️⃣ token 改變 → 建立 / 關閉 socket
  useEffect(() => {
    // 先把舊的 socket 關掉（避免殘留）
    if (socketRef.current) {
      console.log("關閉舊的 socket 連線");
      socketRef.current.disconnect();
      socketRef.current = null;
      setConnected(false);
    }

    // 沒有 token → 不連線
    if (!token) {
      console.log("沒有 token, 不建立 socket");
      return;
    }

    console.log("建立新的 socket 連線，token=", token);

    const socket = io(API_ORIGIN, {
      transports: ["websocket"],
      query: { token },
    });

    socketRef.current = socket;

    socket.on("connect", () => {
      console.log("Socket 連線成功:", socket.id);
      setConnected(true);
    });

    socket.on("disconnect", () => {
      console.log("Socket 已斷線");
      setConnected(false);
    });

    // cleanup：當 token 改變或 Provider unmount 時執行
    return () => {
      console.log("Socket useEffect cleanup");
      socket.disconnect();
      socketRef.current = null;
      setConnected(false);
    };
  }, [token]); // ⭐ 關鍵：依賴「state 的 token」

  return (
    <SocketContext.Provider
      value={{ socket: socketRef.current, connected, setAuthToken }}
    >
      {children}
    </SocketContext.Provider>
  );
}

export function useSocket() {
  return useContext(SocketContext);
}
